import React from 'react';
import { motion } from 'framer-motion';
import { Figma, Framer, Slack, Trello, Github } from 'lucide-react'; // Using Lucide icons as proxies for brand logos
const integrations = [{
  name: 'Figma',
  icon: Figma
}, {
  name: 'Framer',
  icon: Framer
}, {
  name: 'Slack',
  icon: Slack
}, {
  name: 'Notion',
  icon: Trello
}, {
  name: 'GitHub',
  icon: Github
}];
export function Integrations() {
  return <section className="py-20 px-6 border-y border-[#222] bg-[#0a0a0a]" data-id="element-97">
      <div className="max-w-7xl mx-auto text-center" data-id="element-98">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[#666] text-sm font-medium uppercase tracking-widest mb-12" data-id="element-99">
          Works with your favorite tools
        </motion.p>

        <div className="flex flex-wrap justify-center items-center gap-12 md:gap-24" data-id="element-100">
          {integrations.map((tool, index) => <motion.div key={tool.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          scale: 1.1,
          filter: 'brightness(1.2)'
        }} className="group flex flex-col items-center gap-3 cursor-pointer" data-id="element-101">
              <div className="w-12 h-12 flex items-center justify-center text-[#444] group-hover:text-[#ff6b35] transition-colors duration-300" data-id="element-102">
                <tool.icon className="w-8 h-8" data-id="element-103" />
              </div>
              <span className="text-xs font-medium text-[#444] group-hover:text-[#f5f5f5] transition-colors" data-id="element-104">
                {tool.name}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}